import React from "react";
import { useQuery } from '@tanstack/react-query';
import Title from "../layouts/Title";
import Card from "./Card";
import { Cursor, useTypewriter } from "react-simple-typewriter";
import { useTranslation } from "react-i18next";
import { fetchServices } from "../../api";
import { queryKeys } from "../../api/keys";

const Features = () => {
  const { t, i18n } = useTranslation();
  const currentLang = i18n.language;

  const { data: services, isLoading, error } = useQuery({
    queryKey: queryKeys.services(currentLang),
    queryFn: () => fetchServices(currentLang),
  });

  const [text] = useTypewriter({
    words: [t("features.whatDo"), t("features.whatDo")],
    loop: true,
    typeSpeed: 20,
    deleteSpeed: 10,
    delaySpeed: 2000,
  });

  if (isLoading) {
    return (
      <section className="w-full py-20 border-b-[1px] border-b-black">
        <div className="flex justify-center items-center text-white">
          <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-designColor"></div>
        </div>
      </section>
    );
  }

  if (error) {
    return (
      <section className="w-full py-20 border-b-[1px] border-b-black">
        <p className="text-red-500 text-center">Error: {error.message}</p>
      </section>
    );
  }

  const sortedServices = [...services].sort((a, b) => a.order - b.order);

  return (
    <section className="w-full py-20 border-b-[1px] border-b-black">
      <h2 className={`text-5xl font-bold text-white mb-20 ${i18n.language === 'ar' ? 'ar-dir' : 'en-dir'}`}>
        <span>{text}</span>
        <Cursor cursorBlinking="false" cursorStyle={`${i18n.language === 'ar' ? "؟" : "?"} `} cursorColor="#ff014f" />
      </h2>

      <div className={`grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6 xl:gap-20 ${i18n.language === 'ar' ? 'ar-dir' : 'en-dir'}`}>
        {sortedServices.map((service) => (
          <Card key={service.id} service={service} />
        ))}
      </div>
    </section>
  );
};

export default Features;